import "./OraculLoader.css";

const ORACUL_LETTERS = ["O", "R", "A", "C", "U", "L"] as const;

export const OraculLoader = () => (
  <div
    className="oracul-loader-wrapper"
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    <div className="oracul-text-anim">
      {ORACUL_LETTERS.map((letter) => (
        <span key={letter} data-text={letter}>
          {letter}
        </span>
      ))}
    </div>
  </div>
);
